<template>
<w-settings-content-template>
  <div slot="content">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">사용자 목록</div>
        <!-- add xtra-pdng ie friendly 1211 -->
        <el-select class="mr-r4" v-model="activeStatus" @change="loadData" style="width:100px" >
          <el-option label="사용 계정" value="Y"></el-option>
          <el-option label="삭제 계정" value="N"></el-option>
        </el-select>
        <el-button class="mr-r4 xtra-pdng" v-show="activeStatus === 'Y'" @click="clickAddButton">추가</el-button>
        <el-button class="xtra-pdng" v-show="activeStatus === 'Y'" :disabled="checkedActiveRows.length > 0 ? false : true" @click="clickDeleteButton">삭제</el-button>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" type="primary" v-show="activeStatus === 'Y'" @click="setDeviceAuth">장비 권한 설정</el-button>
        <el-button class="mr-r4" size="mini" type="content" v-show="activeStatus === 'Y'" @click="importAccountExcel">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀입력</span>
        </el-button>
        <el-button class="mr-r4" size="mini" type="content" v-show="activeStatus === 'Y'" @click="exportAccountExcel">
          <img src="@/assets/img/icons/excel.png" style="position:relative;left:-2px;bottom:2px;">
          <span style="left:2px;bottom:5px;">  엑셀출력</span>
        </el-button>
        <el-button class="mr-r4 xtra-pdng" type="primary" @click="clickSaveButton" :disabled="isSaved">저장</el-button>
        <el-button class="mr-r4 xtra-pdng"  @click="clickCancelButton" :disabled="isSaved">취소</el-button>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-row>
      <el-table-wrapper v-show="activeStatus === 'Y'" border :data="activeTableData" :columns="activeTableColumns" row-class-name="c-dblclick"
      @selection-change="changeCheckedActiveRows" @row-dblclick="dblclickRow" highlight-current-row :pagination="true" :show-search-tool="showSearchTool"
      :show-custom-header="true" ref="activeTable" :column-default="columnDefault" @condition-change="changeTableCondition" remote :total="total">
        <template slot-scope="scope" slot="lock-status-slot">
          <el-switch v-model="scope.row.lockStatus" active-value="1" inactive-value="0" @change="changeAuthLockTableData"></el-switch>
        </template>
      </el-table-wrapper>
      <el-table-wrapper v-show="activeStatus === 'N'" border :data="inactiveTableData" :columns="inactiveTableColumns" :pagination="true"
      :show-search-tool="showSearchTool" :show-custom-header="true" ref="inactiveTable" :column-default="columnDefault"
      @condition-change="changeTableCondition" remote :total="total">>
        <template slot-scope="scope" slot="active-status-slot">
          <el-switch v-model="scope.row.activeStatus" active-value="Y" inactive-value="N" @change="changeInactiveTableData"></el-switch>
        </template>
        <template slot-scope="scope" slot="lock-status-slot">
          <el-switch v-model="scope.row.lockStatus" active-value="1" inactive-value="0" @change="changeInactiveTableData"></el-switch>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-user-popup ref="userPopup" :popup-type="popupType" @reload-data="loadData" :selected-user-id="selectedUserId" />
    <w-import-excel-account-setting-popup ref="importExcelSyncSlidingPopup" @reload-data="loadData" />
    <w-device-auth-setting-popup ref="deviceAuthSettingPopup" />
  </div>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import { differenceWith, cloneDeep, isNil, isEqual } from 'lodash';
import msgUtil from '@/utils/message';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import UserSettingAPI from '@/api/settings/user/user-setting';
import FileApi from '@/api/common/file';
import WUserPopup from './popup/UserPopup';
import WImportExcelAccountSettingPopup from './popup/ImportExcelAccountSettingPopup';
import WDeviceAuthSettingPopup from './popup/DeviceAuthSettingPopup/index';

export default {
  name: 'WUserSetting',
  components: {
    WSettingsContentTemplate,
    WUserPopup,
    WImportExcelAccountSettingPopup,
    WDeviceAuthSettingPopup,
  },
  data() {
    return {
      columnDefault,
      activeTableColumns: [
        {
          type: 'selection',
        },
        {
          prop: 'managerId',
          label: 'ID',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managerName',
          label: '이름',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managerTypeLabel',
          label: '역할',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'association',
          label: '소속',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'department',
          label: '부서',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'grade',
          label: '직급',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'empno',
          label: '사번',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'mobileNumber',
          label: '모바일',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'telNumber',
          label: '내선번호',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'lastLoginDatetime',
          label: '마지막 로그인 시각',
          searchable: true,
          searchType: 'date',
          width: 150,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'registDatetime',
          label: '계정 생성시각',
          searchable: true,
          searchType: 'date',
          width: 150,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'lockStatus',
          label: '계정 잠금',
          width: 90,
          align: 'center',
          scopedSlot: 'lock-status-slot',
        },
      ],
      inactiveTableColumns: [
        {
          prop: 'activeStatus',
          label: '계정 활성화',
          width: 90,
          align: 'center',
          scopedSlot: 'active-status-slot',
        },
        {
          prop: 'managerId',
          label: 'ID',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managerName',
          label: '이름',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'managerTypeLabel',
          label: '역할',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'association',
          label: '소속',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'department',
          label: '부서',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'grade',
          label: '직급',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'empno',
          label: '사번',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'mobileNumber',
          label: '모바일',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'telNumber',
          label: '내선번호',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'lastLoginDatetime',
          label: '마지막 로그인 시각',
          searchable: true,
          searchType: 'date',
          width: 150,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'registDatetime',
          label: '계정 생성시각',
          searchable: true,
          searchType: 'date',
          width: 150,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'lockStatus',
          label: '계정 잠금',
          width: 90,
          align: 'center',
          scopedSlot: 'lock-status-slot',
        },
      ],
      isSaved: true,
      activeStatus: 'Y',
      checkedActiveRows: [],
      showSearchTool: false,
      total: 0,
      activeTableData: null,
      activeTableOriginData: null,
      inactiveTableData: null,
      inactiveTableOriginData: null,
      changedInactiveRows: [],
      changedActiveRows: [],
      popupType: 'add',
      selectedUserId: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      const tableParams = isEqual(this.activeStatus, 'Y') ? this.$refs.activeTable.getParameter() : this.$refs.inactiveTable.getParameter();
      const params = {
        activeStatus: this.activeStatus,
        ...tableParams,
      };
      UserSettingAPI.getUserList(params).then((response) => {
        if (isEqual(this.activeStatus, 'Y')) {
          this.activeTableData = response.data.data;
          this.total = response.data.total;
          this.activeTableOriginData = cloneDeep(response.data.data);
          this.changeAuthLockTableData();
        } else {
          this.inactiveTableData = response.data.data;
          this.inactiveTableOriginData = cloneDeep(response.data.data);
          this.total = response.data.total;
          this.changeInactiveTableData();
        }
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    changeCheckedActiveRows(selection) {
      this.checkedActiveRows = selection;
    },
    // 추가팝업
    clickAddButton() {
      this.selectedUserId = null;
      this.popupType = 'add';
      this.$nextTick(() => {
        this.$refs.userPopup.$refs.slidingPopup.visible = true;
      });
    },
    // 수정팝업
    dblclickRow(row) {
      this.selectedUserId = cloneDeep(row.managerId);
      this.popupType = 'update';
      this.$nextTick(() => {
        this.$refs.userPopup.$refs.slidingPopup.visible = true;
      });
    },
    /**
     * [clickDeleteButton 사용자 목록에서 사용 계정을 삭제 계정으로 전환한다.]
     * @author yelim
     */
    clickDeleteButton() {
      const checkedList = this.checkedActiveRows;
      const administrator = checkedList.filter((item) => item.managerId === 'administrator')[0];
      if (!isNil(administrator)) {
        this.$message('administrator 계정은 삭제하실 수 없습니다.');
        return;
      }
      const deleteList = [];
      const messageName = '사용자';
      checkedList.forEach((item) => {
        deleteList.push({
          managerId: item.managerId,
          activeStatus: 'N',
        });
      });
      // 사용 계정에서 삭제 계정으로 전환한다.
      // activeStatus Y->N 전환
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        UserSettingAPI.updateMgrInfo(deleteList).then((response) => {
          if (response.data.success) {
            this.loadData();
            this.$message(msgUtil.getResultMsgData(action, messageName, true));
          }
        });
      }).catch(() => {});
    },
    /**
     * [clickSaveButton 사용 계정/ 삭제 계정에 따라 변경된 정보를 저장한다.]
     * @author yelim
     */
    clickSaveButton() {
      const params = [];
      let messageName = '';
      // 사용 계정과 삭제 계정 리스트에 따른 파라미터를 분기
      if (isEqual(this.activeStatus, 'Y')) {
        // 변경된 항목중 계정 잠금이 변경된 내용을 업데이트 한다.
        this.changedActiveRows.forEach((item) => {
          params.push({
            managerId: item.managerId,
            lockStatus: item.lockStatus,
          });
        });
        messageName = '계정 잠금 정보';
      } else {
        // 변경된 항목중 계정 잠금 또는 활성화 여부가 변경된 내용을 업데이트 한다.
        this.changedInactiveRows.forEach((item) => {
          params.push({
            managerId: item.managerId,
            activeStatus: item.activeStatus,
            lockStatus: item.lockStatus,
          });
        });
        messageName = '계정 정보';
      }
      UserSettingAPI.updateMgrInfo(params).then((response) => {
        if (response.data.success) {
          this.loadData();
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, messageName, true));
        }
      });
    },
    clickCancelButton() {
      this.loadData();
    },
    changeInactiveTableData() {
      const data = this.inactiveTableData;
      const origin = this.inactiveTableOriginData;
      this.changedInactiveRows = differenceWith(data, origin, isEqual);
      this.isSaved = !(this.changedInactiveRows.length > 0);
    },
    changeAuthLockTableData() {
      const data = this.activeTableData;
      const origin = this.activeTableOriginData;
      this.changedActiveRows = differenceWith(data, origin, isEqual);
      this.isSaved = !(this.changedActiveRows.length > 0);
    },
    changeTableCondition() {
      this.loadData();
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 사용자 계정 목록 엑셀 출력
     * @author Song
     */
    exportAccountExcel() {
      const tableParams = this.$refs.activeTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        ...tableParams,
      };

      this.loadingText = '엑셀 출력 중..';
      this.loading = true;
      UserSettingAPI.exportUserList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        })
        .finally(() => {
          this.loading = false;
          this.loadingText = null;
        });
    },
    /**
     * 사용자 계정 목록 엑셀 입력 - 수정
     * @author Song
     */
    importAccountExcel() {
      // 템플릿은 엑셀 출력 시 생성한 파일
      // validation 공백체크 및 e-mail이 대상이며 서비스단에서 처리 후 수정 성공/실패 여부만 리턴
      this.$refs.importExcelSyncSlidingPopup.open();
    },
    /**
     * 장비권한설정 팝업 오픈,
     * @author najong
     */
    setDeviceAuth() {
      this.$refs.deviceAuthSettingPopup.open();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/index.vue